import React from 'react'

function Grades() {
  return (
    <div>
      Grades
    </div>
  )
}

export default Grades
